import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import games from './games';
import wordmark from './images/voidmaw-wordmark.png';
import katanautLogo from './images/logo-web.png';
import katanautPoster from './images/header-poster.jpg';
import './Landing.css';

let katanautWarmupStarted = false;

function warmKatanaut() {
  if (katanautWarmupStarted || typeof document === 'undefined') return;
  katanautWarmupStarted = true;

  [
    [katanautLogo, 'image'],
    [katanautPoster, 'image'],
  ].forEach(([href, as]) => {
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = as;
    document.head.appendChild(link);
  });
}

function Landing() {
  const releasedGame = games.find((game) => game.status === 'OUT NOW') || games[0];
  const developingGame = games.find((game) => game.status === 'IN DEVELOPMENT');

  return (
    <main className="landing">
      <Helmet>
        <title>Voidmaw Games</title>
        <meta name="description" content="Voidmaw is a one-person game studio." />
        <meta property="og:url" content="https://www.voidmaw.com" />
        <meta property="og:title" content="Voidmaw Games" />
        <meta property="og:description" content="Voidmaw is a one-person game studio." />
      </Helmet>

      <section className="landing-panel" aria-labelledby="studio-name">
        <h1 id="studio-name" className="landing-title">
          <img src={wordmark} alt="Voidmaw" />
        </h1>

        <p className="landing-byline">A one-person game studio. Blame accordingly.</p>

        <div className="landing-details">
        {developingGame && (
          <div className="landing-announcement">
            <p className="landing-release-line">
              <span className="landing-coming-soon">Coming soon:</span> <span className="landing-game-label landing-game-label-pending">Unannounced</span>
            </p>
          </div>
        )}

        <p className="landing-release-line">
          Out now: <Link to={releasedGame.path} className="landing-game-label" onPointerEnter={warmKatanaut} onFocus={warmKatanaut}>{releasedGame.title}</Link>
        </p>

        <nav className="landing-links" aria-label="Voidmaw links">
          <a href="https://store.steampowered.com/search/?developer=Voidmaw" target="_blank" rel="noopener noreferrer">Steam</a>
          <a href="https://www.youtube.com/@VoidmawGames/videos" target="_blank" rel="noopener noreferrer">YouTube</a>
          <a href="https://x.com/VoidmawGames" target="_blank" rel="noopener noreferrer">Twitter</a>
          <Link to="/contact">Contact</Link>
        </nav>

        <a className="landing-mail" href="mailto:contact@voidmaw.com" aria-label="Email Voidmaw">
          <svg aria-hidden="true" viewBox="0 0 32 24" fill="none">
            <rect x="1" y="1" width="30" height="22" rx="1.5" />
            <path d="M2 3l14 10L30 3" />
          </svg>
        </a>
        </div>
      </section>
    </main>
  );
}

export default Landing;
